// Lokale runtime-config voor de app. Niet in de seed omdat dit per gebruiker
// kan verschillen (waar logeer je?).

// Chalet — adres "Suchá 34, Jáchymov, Česká republika".
// De coördinaten zijn een redelijke gok op basis van het straatverloop;
// als 't pin een paar straten verkeerd staat, finetune dan hier of vraag
// een precieze positie op via mapy.cz/openstreetmap.
export const CHALET = {
  name: 'Onze chalet',
  address: 'Suchá 34, Jáchymov',
  coord: { lat: 50.3635, lng: 12.9210 },
  // Optionele extra info voor de popup
  note: 'Thuisbasis',
}
